import { Component, OnInit, AfterViewInit } from '@angular/core';

declare let ScrollMagic: any;

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss']
})
export class MainComponent implements OnInit, AfterViewInit {

  innerHeight: string;
  scenes: any;
  controller: any;
  innerWidth: number;

  constructor() { }

  ngOnInit() {
    this.innerWidth = window.innerWidth;
    if (this.innerWidth < 961) {
      this.controller.enabled(false);
    }
  }

  ngAfterViewInit() {
  	// this.innerHeight = (window.innerHeight) + "px";
  	// this.scenes = document.getElementsByClassName('scene');

    const wrapHeight = document.getElementById('project-2').offsetHeight;
    this.controller = new ScrollMagic.Controller();

    const title = new ScrollMagic.Scene({
        triggerElement: '#header-scene',
        duration: wrapHeight / 3,
        offset: wrapHeight - 250
      })
      .setTween('#header-scene .description', .5, { opacity: 0 })
      // .addIndicators({name: 'title'})
      .addTo(this.controller);

    const headerImg = new ScrollMagic.Scene({
        triggerElement: '#header-scene',
        duration: wrapHeight / 3,
        offset: wrapHeight - 250
      })
      .setTween('#header-scene .image', .5, { opacity: 0 })
      // .addIndicators({name: 'title'})
      .addTo(this.controller);

    const header = new ScrollMagic.Scene({
        triggerElement: '#header-scene',
        duration: wrapHeight / 3,
        offset: wrapHeight - 250
      })
      .setTween('#header-scene', .5, { background: 'white' })
      // .addIndicators({name: 'title'})
      .addTo(this.controller);

    const project1 = new ScrollMagic.Scene({
        triggerElement: '#project-1',
        duration: '100%'
      })
      .setClassToggle('#project-1', 'active')
      // .addIndicators({name: 1})
      .addTo(this.controller);

    const project2 = new ScrollMagic.Scene({
        triggerElement: '#project-2',
        duration: '100%'
      })
      .setClassToggle('#project-2', 'active')
      // .addIndicators({name: 2})
      .addTo(this.controller);

    const project3 = new ScrollMagic.Scene({
        triggerElement: '#project-3',
        duration: '100%'
      })
      .setClassToggle('#project-3', 'active')
      // .addIndicators({name: 2})
      .addTo(this.controller);

    // this.scenes = document.querySelectorAll('[id*="project-"');
  	// this.setHeight(this.scenes, this.innerHeight);

    // this.buildScenes();
  }

  buildScenes() {
    for (let i = 1; i <= this.scenes.length - 1; i++) {
      new ScrollMagic.Scene({
        triggerElement: '#project-' + i,
        duration: '100%'
      })
      .setClassToggle('#project-' + i, 'active')
      .addIndicators({name: i})
      .addTo(this.controller);
    }
  }

  // setHeight(scenes, height) {
  // 	console.log(scenes.length);
  // 	for(var i = 0; i < scenes.length; i ++) {
  // 		scenes[i].style.height = height;
  // 	}
  // }

}



// WEBPACK FOOTER //
// /Users/dearmom/Sites/portfolio/src/app/main/main.component.ts